module.exports = __webpack_public_path__ + "img/chuju.73c00ce6.png";